import React from 'react'
import Helmet from '../components/Helmet/Helmet'
import CommonSection from '../components/UI/CommonSection'
import { Container,Row,Col } from 'react-bootstrap'
import {motion} from 'framer-motion'
import { cartActions } from '../redux/slices/cartSlice'
import { useSelector,useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import '../assets/style/cart.css'
const Cart = () => {

    const cartItems = useSelector((state)=>state.cart.cartItems);
    const totalAmount = useSelector((state)=>state.cart.totalAmount)

    return (
        <>
            <Helmet title='Cart'/>
            <CommonSection title='Shopping Cart'/>

            <section>
                <Container>
                    <Row>
                        <Col lg='9'>
                            {

                                cartItems.length ===0? <h2 className='fs-4 text-center'>No item added to Cart</h2> :
                                <table className='table bordered'>
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>Title</th>
                                            <th>Price</th>
                                            <th>Qty</th>
                                            <th>Delete</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            cartItems?.map((item,index)=>{
                                                return(
                                                    <Tr key={index} item={item}/>
                                                )
                                            })
                                        }
                                    </tbody>
                                    
                                </table>
                            }
                            
                        </Col>

                        <Col lg='3'>
                            <div>
                                <h6 className='d-flex align-items-center justify-content-between'>
                                    Subtotal
                                    <span className='fs-4 fw-bold'>${totalAmount}</span>
                                </h6>
                            </div>
                            <p>Taxes and shipping will calulate in checkout</p>
                            <div>
                                <button className="buy__btn w-100">
                                    <Link to='/shop'>Continue Shopping</Link>
                                </button>
                                <button className="buy__btn w-100 mt-3">
                                    <Link to='/checkout'>CheckOut</Link>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    )
}

const Tr = ({item})=>{

    const dispatch = useDispatch()
    const deleteProduct = ()=>{
        dispatch(cartActions.deleteItem(item.id))
    }

    return(
        <tr>
            <td><img src={item.imgUrl} alt="product" /></td>
            <td>{item.productName}</td>
            <td>${item.price}</td>
            <td>{item.quantity}</td>
            <td><motion.i
                onClick={deleteProduct}
                whileTap={{scale:1.3}} className='ri-delete-bin-line'></motion.i></td>
        </tr>
    )
}

export default Cart